import { declOfNum } from '@ertelecom/ui-react/components/helpers';

export const monthText = declOfNum(['месяц', 'месяца', 'месяцев']);

export const getRALifeTime = (time: number): number => {
    time++;
    return time;
};

export const showOfferLink = (link: string): void => {
    if (window) {
        window.open(link, '_blank');
    }
};
